export default __webpack_public_path__ + "static/email-c9659d6b0c73eb9cdb532f3197bbb77d.svg";